import { SxProps } from '@mui/material';
import { CSSProperties } from 'react';
import { BORDER_COLOR } from '../../../../shared/constants';

export const HORIZONTAL_SPACING = 18;

export const ACCORDION_VIRTUAL_KEY_PAIR_HEIGHT = 70;

export const ACCORDION_VIRTUAL_KEY_PAIR_GAP = 8;

export const SMALL_BUTTON_WIDTH = 100;

export const SMALL_INPUT_HEIGHT = 40;

export const SMALL_INPUT_WIDTH = 125;

export const LARGE_INPUT_WIDTH = 300;

export const DELETE_ICON_SPACING = 12;

export const DELETE_ICON_HEIGHT = 36;

export const DELETE_ICON_WIDTH = 36;

export const API_RESPONSE_WIDTH = 400;

export const FLOW_API_CALL_FILE = 'FLOW_API_CALL_FILE';

export const MODAL_HEADER_HEIGHTS = {
  HEADER_TITLE: 60,
  API_NAME: 58,
  API_METHOD: 58,
  API_TAB_DIVIDER: 3,
  API_TAB_HEADER: 67,
  API_TAB_FOOTER: 55,
};

export const requestTabStyle: SxProps = {
  fontSize: '16px',
  fontWeight: '600',
  color: 'inherit',
  height: `${
    MODAL_HEADER_HEIGHTS.API_TAB_HEADER -
    HORIZONTAL_SPACING -
    MODAL_HEADER_HEIGHTS.API_TAB_DIVIDER
  }px`,
  '&.Mui-selected': {
    color: 'inherit',
  },
};

export const requestTabPanelStyle: CSSProperties = {
  height: `calc(100% - ${
    MODAL_HEADER_HEIGHTS.API_NAME +
    MODAL_HEADER_HEIGHTS.API_METHOD +
    MODAL_HEADER_HEIGHTS.API_TAB_HEADER
  }px)`,
  overflow: 'auto',
};

export const responseTabStyle: SxProps = {
  fontSize: '16px',
  fontWeight: '600',
  color: 'inherit',
  height: `${
    MODAL_HEADER_HEIGHTS.API_TAB_HEADER -
    HORIZONTAL_SPACING -
    MODAL_HEADER_HEIGHTS.API_TAB_DIVIDER
  }px`,
  '&.Mui-selected': {
    color: 'inherit',
  },
};

export const responseTabPanelStyle: CSSProperties = {
  height: `calc(100% - ${
    MODAL_HEADER_HEIGHTS.HEADER_TITLE +
    MODAL_HEADER_HEIGHTS.API_TAB_HEADER -
    HORIZONTAL_SPACING
  }px)`,
  overflow: 'auto',
};

export const autocompleteHeaderKeyStyle: SxProps = {
  height: `${SMALL_INPUT_HEIGHT}px`,
  border: `1px solid ${BORDER_COLOR}`,
  borderRadius: '4px',
  width: '100%',
  '.MuiTextField-root': {
    height: `${SMALL_INPUT_HEIGHT - 2}px`,
  },
  '.MuiOutlinedInput-root': {
    color: 'black',
    height: `${SMALL_INPUT_HEIGHT - 2}px`,
    width: '100%',
    padding: '0px',
    paddingRight: '0px !important',
    borderColor: BORDER_COLOR,
  },
  '.MuiAutocomplete-endAdornment': {
    display: 'none',
  },
  '.MuiAutocomplete-input': {
    color: 'black',
    height: `${SMALL_INPUT_HEIGHT - 2}px`,
    padding: '0px 10px !important',
    borderColor: BORDER_COLOR,
  },
  '.MuiOutlinedInput-notchedOutline': {
    height: `${SMALL_INPUT_HEIGHT - 2}px`,
    width: '100%',
    border: 'none',
    borderColor: BORDER_COLOR,
  },
  '.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: BORDER_COLOR,
  },
  '.MuiAutocomplete-input::-webkit-input-placeholder': {
    color: '#737373',
  },
};

export const accordionStyle: SxProps = {
  boxShadow: 'none',
  border: 'none',
  borderRadius: '0px',
  padding: '8px 14px',
  '&.Mui-expanded': {
    margin: '0px',
    paddingBottom: '16px',
  },
  '&::before': {
    display: 'none',
  },
  '&:first-of-type': {
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
    paddingTop: '0px',
  },
  '&:last-of-type': {
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    paddingBottom: '0px',
  },
  '&:not(:last-child)': {
    borderBottom: `1px solid #dcdcdc`,
  },
  '.MuiAccordionSummary-root': {
    padding: '0px',
    minHeight: 'unset !important',
  },
  '.MuiAccordionSummary-content': {
    margin: '0px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'black',
  },
  '.MuiAccordionSummary-content.Mui-expanded': {
    margin: '0px',
  },
  '.MuiAccordionDetails-root': {
    padding: '8px 0px 0px 0px',
    overflow: 'auto',
  },
};

export const apiInputStyle: SxProps = {
  color: 'black',
  border: `1px solid ${BORDER_COLOR}`,
  padding: '3px 10px',
  borderRadius: '4px',
  outline: 'none',
  minHeight: `${SMALL_INPUT_HEIGHT}px`,
  height: `${SMALL_INPUT_HEIGHT}px`,
  width: '100%',
};

export const VARIABLE_REGEX = new RegExp(/{{.{1,10000}?}}/, 'g');
